// client/src/components/vendas/FiltroVendas.js
import React, { useState } from 'react';
import { Search, XCircle as ClearIcon, Calendar } from 'lucide-react';
import { useClientesDaConta } from '../../hooks/useVendaFormData';

const initialFilterState = {
    search: '',
    statusVenda: '',
    statusPagamento: '',
    startDate: '',
    endDate: '',
    cliente: ''
};

const FiltroVendas = ({ onApplyFilters, loading }) => {
    const [localFilters, setLocalFilters] = useState(initialFilterState);
    const { data: clientesData, isLoading: loadingClientes } = useClientesDaConta();
    const clientes = Array.isArray(clientesData) ? clientesData : [];

    const onChange = e => {
        setLocalFilters({ ...localFilters, [e.target.name]: e.target.value });
    };

    const onSubmit = e => {
        e.preventDefault();
        if (onApplyFilters) {
            const activeFilters = Object.fromEntries(
                Object.entries(localFilters).filter(([_, v]) => v !== '' && v !== null)
            );
            onApplyFilters(activeFilters);
        }
    };

    const handleClearFilters = () => {
        setLocalFilters(initialFilterState);
        if (onApplyFilters) {
            onApplyFilters({});
        }
    };
    
    const isAnyFilterActive = () => {
        return Object.values(localFilters).some(v => v !== '');
    };

    return (
        <form onSubmit={onSubmit}>
            <div className="form-grid-container">
                <div className="form-group">
                    <label htmlFor="filter-search">Buscar</label>
                    <input 
                        type="text" 
                        name="search" 
                        id="filter-search" 
                        placeholder="Cliente, código, descrição..." 
                        value={localFilters.search} 
                        onChange={onChange} 
                        className="form-input"
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="filter-statusVenda">Status da Venda</label>
                    <select 
                        name="statusVenda" 
                        id="filter-statusVenda" 
                        value={localFilters.statusVenda} 
                        onChange={onChange} 
                        className="form-input"
                    >
                        <option value="">Todos</option>
                        <option value="Aberta">Aberta</option>
                        <option value="Finalizada">Finalizada</option>
                        <option value="Cancelada">Cancelada</option>
                    </select>
                </div>
                
                <div className="form-group">
                    <label htmlFor="filter-statusPagamento">Status Pagamento</label>
                    <select 
                        name="statusPagamento" 
                        id="filter-statusPagamento" 
                        value={localFilters.statusPagamento} 
                        onChange={onChange} 
                        className="form-input"
                    >
                        <option value="">Todos</option>
                        <option value="Pendente">Pendente</option>
                        <option value="Parcialmente Pago">Parcialmente Pago</option>
                        <option value="Pago">Pago</option>
                        <option value="Inadimplente">Inadimplente</option>
                    </select>
                </div>
                
                <div className="form-group">
                    <label htmlFor="filter-cliente">Cliente</label>
                    <select
                        name="cliente"
                        id="filter-cliente"
                        value={localFilters.cliente}
                        onChange={onChange}
                        className="form-input"
                        disabled={loadingClientes}
                    >
                        <option value="">Todos</option>
                        {clientes.map(cliente => (
                            <option key={cliente._id} value={cliente._id}>
                                {cliente.nome}
                                {cliente.telefone ? ` - ${cliente.telefone}` : ''}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div className="form-group col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        <Calendar size={16} className="inline mr-1" />
                        Período
                    </label>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label htmlFor="filter-startDate" className="block text-xs text-gray-600 mb-1">
                                Data Inicial
                            </label>
                            <input 
                                type="date" 
                                name="startDate" 
                                id="filter-startDate" 
                                value={localFilters.startDate} 
                                onChange={onChange} 
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label htmlFor="filter-endDate" className="block text-xs text-gray-600 mb-1">
                                Data Final
                            </label>
                            <input 
                                type="date" 
                                name="endDate" 
                                id="filter-endDate" 
                                value={localFilters.endDate} 
                                onChange={onChange} 
                                className="form-input"
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="form-actions">
                <button 
                    type="button" 
                    onClick={handleClearFilters} 
                    className="action-button action-button-secondary" 
                    disabled={!isAnyFilterActive() || loading}
                >
                    <ClearIcon size={18} className="icon"/> 
                    Limpar Filtros
                </button>
                <button 
                    type="submit" 
                    className="action-button action-button-primary" 
                    disabled={loading}
                >
                    <Search size={18} className="icon"/> 
                    Aplicar Filtros
                </button>
            </div>
        </form>
    );
};

export default FiltroVendas;